import { render, staticRenderFns } from "./AppBootProgress.vue?vue&type=template&id=97b70d8a&"
import script from "./AppBootProgress.vue?vue&type=script&lang=js&"
export * from "./AppBootProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports